<template>
  <div class="overflow-x-hidden overflow-y-hidden">
    <!-- Header -->
    <div class="flex flex-col items-center p-4">
      <Header class="w-full" />
      <!--       <div
        class="inline-flex items-center rounded-full text-gray-800 bg-gray-200 text-xs w-64 h-10 p-1 mt-4"
      >
        <div
          class="p-2 rounded-full cursor-pointer w-1/3 text-center noSelect"
          v-for="filter in filters"
          :key="filter"
          :class="{ 'bg-white': selectedFilter === filter }"
          @click="selectFilter(filter)"
        >
          {{ filter }}
        </div>
      </div> -->
    </div>

    <!-- Search -->
    <SearchPlace v-show="onSearch" />
    <!-- <Search v-show="onSearch" /> -->
    <!-- Map -->
    <Map v-show="!onSearch" class="w-full h-[85.8vh]" />
    <!-- journeys -->

    <div
      v-if="!$store.state.itineraire.onSearch"
      class="overflow-x-hidden overflow-y-hidden"
    >
      <Travels
        v-if="$store.state.journeysLoaded && !$store.state.journeySelected"
        :journeys="$store.state.itineraire.journeys"
        class="absolute bottom-0 w-full mb-4"
      />
      <Travel
        v-if="$store.state.journeysLoaded && $store.state.journeySelected"
        :travel="$store.state.itineraire.selectedJourney"
        class="absolute bottom-0 w-full"
      />
    </div>
  </div>
</template>

<style>
.mapboxgl-ctrl-bottom-right {
  display: none !important;
}
.mapboxgl-ctrl {
  display: none !important;
}
</style>

<script>
import SearchPlace from "@/components/itineraire/SearchPlace.vue";

import Header from "@/components/itineraire/Header.vue";
import Map from "@/components/itineraire/Map.vue";
import Travels from "@/components/itineraire/Travels.vue";
import Travel from "@/components/itineraire/Travel.vue";

import { mapGetters } from "vuex";

export default {
  name: "itineraire",
  components: {
    Header,
    SearchPlace,
    Map,
    Travels,
    Travel
  },
  data() {
    return {
      journeys: [],
      filters: ["🚌", "Les deux", "🚊"],
      selectedFilter: "Les deux"
    };
  },
  computed: {
    ...mapGetters(["itineraire"]),
    onSearch() {
      const { onSearch, query } = this.$store.state.itineraire;
      return onSearch && query;
    },
    travelSelected() {
      const { selected } = this.$store.state.itineraire;
      return (
        null !== selected && null !== selected.from && null !== selected.to
      );
    }
  },
  methods: {
    selectFilter(filter) {
      this.$store.commit("selectLineFilter", filter);
      this.selectedFilter = filter;
    }
  }
};
</script>
